import { render, staticRenderFns } from "./rightBot.vue?vue&type=template&id=08d0da8a&scoped=true&lang=true&"
import script from "./rightBot.vue?vue&type=script&lang=js&"
export * from "./rightBot.vue?vue&type=script&lang=js&"
import style0 from "./rightBot.vue?vue&type=style&index=0&id=08d0da8a&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08d0da8a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("K:\\website\\tmp\\2021.7-12\\mmlzcyy_project\\screen\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('08d0da8a')) {
      api.createRecord('08d0da8a', component.options)
    } else {
      api.reload('08d0da8a', component.options)
    }
    module.hot.accept("./rightBot.vue?vue&type=template&id=08d0da8a&scoped=true&lang=true&", function () {
      api.rerender('08d0da8a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/page/scyxDrawer/rightBar/rightBot.vue"
export default component.exports